import { render, staticRenderFns } from "./VectorBuilder.vue?vue&type=template&id=341d8c77&scoped=true"
import script from "./VectorBuilder.vue?vue&type=script&lang=js"
export * from "./VectorBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341d8c77",
  null
  
)

export default component.exports